class CartRewardBar extends HTMLElement {
  connectedCallback() {
    this.gwpVariantId = parseInt(this.dataset.gwpVariantId, 10) || 0;
    this.moneyFormat = window.FoxTheme.settings.moneyFormat;
    this.progress = this.querySelector('[data-progress]');
    this.messages = Array.from(this.querySelectorAll('[data-message-index]'));
    this.completedMessage = this.querySelector('[data-message-complete]');
    this.milestones = Array.from(this.querySelectorAll('[data-milestone]')).map((element) => ({
      element,
      amount: parseInt(element.dataset.amount, 10) || 0,
      position: parseInt(element.dataset.position, 10) || 0,
      basis: element.dataset.basis,
    }));

    this.update({
      gift: parseInt(this.dataset.giftTotal, 10) || 0,
      order: parseInt(this.dataset.orderTotal, 10) || 0,
    });

    this.onCartUpdated = (event) => this.refresh(event.detail.cart);
    document.addEventListener('cart:updated', this.onCartUpdated);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:updated', this.onCartUpdated);
  }

  /**
   * Each milestone is measured the way its reward is granted, mirroring the Liquid
   * render. The gift counts the selling price before any discount, without compare-at
   * prices — what the gift-with-purchase function in mlc-app checks — and without the
   * gift line, which <gwp-sync> adds once the threshold is reached and would make the
   * progress jump. Free shipping counts the cart total after discounts, as Shopify's
   * shipping rates do.
   */
  refresh(cart) {
    const gift = (cart.items || [])
      .filter((item) => !this.gwpVariantId || item.id !== this.gwpVariantId)
      .reduce((sum, item) => sum + item.original_line_price, 0);

    this.update({ gift, order: cart.total_price || 0 });
  }

  update(totals) {
    if (!this.milestones.length) return;

    this.classList.toggle('hidden', totals.gift <= 0);

    const totalFor = (milestone) => (milestone.basis === 'gift' ? totals.gift : totals.order);
    const nextIndex = this.milestones.findIndex((milestone) => totalFor(milestone) < milestone.amount);
    const isComplete = nextIndex === -1;

    this.milestones.forEach((milestone) => {
      milestone.element.classList.toggle('cart-reward-bar__milestone--reached', totalFor(milestone) >= milestone.amount);
    });

    this.messages.forEach((message, index) => {
      message.hidden = isComplete || index !== nextIndex;
    });
    this.completedMessage.hidden = !isComplete;
    this.classList.toggle('cart-reward-bar--complete', isComplete);

    if (!isComplete) {
      const next = this.milestones[nextIndex];
      const previous = nextIndex === 0 ? { amount: 0, position: 0 } : this.milestones[nextIndex - 1];
      const total = totalFor(next);
      const span = next.amount - previous.amount;
      const ratio = span > 0 ? (total - previous.amount) / span : 0;

      this.messages[nextIndex].querySelector('[data-left-to-spend]').innerHTML = FoxTheme.Currency.formatMoney(
        next.amount - total,
        this.moneyFormat
      );

      this.setPercent(previous.position + (next.position - previous.position) * Math.min(Math.max(ratio, 0), 1));
    } else {
      this.setPercent(100);
    }
  }

  setPercent(percent) {
    this.progress.style.setProperty('--percent', `${percent}%`);
  }
}
customElements.define('cart-reward-bar', CartRewardBar);
